
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import Notify from 'vue-notification';

import { Order } from '@/models/order';
import { Product } from '@/models/product';
import { Cart } from '@/models/cart';

import ListCart from './ListCart.vue';
import ConfirmModal from '@/shared/components/ConfirmModal.vue';

import commonService from '@/services/common-services';
import cartServices from '@/services/cart-services';
import authService from '@/services/auth-services';

import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

const numeral = require('numeral');


@Component({
    components: {
        Loading,
        ListCart,
        ConfirmModal
    }
})
export default class ConfirmCart extends Vue {
    private feeBuyProRange: any;
    private isUseWallet = false;
    private isConfirmWallet = false;
    private customerInfo: any = {};
    private isLoading = false;
    private listCart: Cart[] = [];
    private cartStatus = 0;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get param() {
        return this.$route.params.cartIds;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    get minFeeBuy() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].minFeeBuy;
    }
    
    get feeBuyPro() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].feeBuyPro;
    }

    get customerLevels() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].customerLevels;
    }

    get customerLevelsDiscount() {
        return this.customerLevels.find((cl) => cl.ID === (this.customerInfo.LevelID || 1));
    }

    get totalAmountCart() {
        return this.listCart.reduce((total, cart) => {
            return total + cart.totalAmount;
        }, 0);
    }

    get cartSelected() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].cartSelected;
    }

    get amountGoods() {
        return {
            amount: this.listCart.reduce((amount: number, cart: Cart) => {
                        return amount + cart.amount;
                    }, 0),
            amountCN: this.listCart.reduce((amount: number, cart: Cart) => {
                        return amount + cart.amountCN;
                    }, 0),
        };
    }

    get totalFeeBuyPro() {
        return {
            feeBuyPro: this.listCart.reduce((feeBuyPro: number, cart: Cart) => {
                        return feeBuyPro + cart.feeBuyPro;
                    }, 0),
            feeBuyProCN: this.listCart.reduce((feeBuyPro: number, cart: Cart) => {
                        return feeBuyPro + cart.feeBuyProCN;
                    }, 0),
        };
    }

    get totalAmountGoods() {
        return {
            totalAmount: this.listCart.reduce((totalAmount: number, cart: Cart) => {
                        return totalAmount + cart.totalAmount;
                    }, 0),
            totalAmountCN: this.listCart.reduce((totalAmountCN: number, cart: Cart) => {
                        return totalAmountCN + cart.totalAmountCN;
                    }, 0),
        };
    }

    get totalDeposit() {
        return {
            deposit: this.listCart.reduce((deposit: number, cart: Cart) => {
                        return deposit + cart.deposit;
                    }, 0),
            depositCN: this.listCart.reduce((depositCN: number, cart: Cart) => {
                        return depositCN + cart.depositCN;
                    }, 0),
        };
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async created() {
        await this.getCustomersInfo();
        if (!this.rate) {
            await this.getRate();
        }
        if (!this.feeBuyPro) {
            await this.getFeeBuyPro();
        }
        if (!this.customerLevels) {
            await this.getCustomerLevels();
        }
        if (!this.warehouse) {
            await this.getWarehouse();
        }

        await this.loadData();
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      }
    }

    private async getFeeBuyPro() {
        const result = await commonService.feeBuyPro();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_FEE_BUY_PRO', result.data.data);
        }
    }

    private async getCustomersInfo() {
        const result = await authService.customersInfo(this.userInfo.userId);
        if(result && result.status === 200) {
            this.customerInfo = result.data.data || {};
            (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
        }
    }

    private async getCustomerLevels() {
        const result = await commonService.getCustomerLevels();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_CUSTOMER_LEVELS', result.data.data);
        }
    }

    private async loadData() {
        if (this.cartSelected === null) {
            this.onComeback();
            return;
        }
        this.isLoading = true;
        this.listCart = this.cartSelected.map(cart => {
            const amount = cart.products.reduce((val, product) => {
                                return val + product.amount;
                            }, 0);
            const feeBuyPro = this.calculateFeeBuyPro(amount);
            const deposit = this.calculateDeposit(amount, feeBuyPro);
            const totalAmount = amount + feeBuyPro;

            return {
                ...cart,
                amount,
                amountCN: amount / this.rate,
                feeBuyPro,
                feeBuyProCN: feeBuyPro / this.rate,
                deposit,
                depositCN: deposit / this.rate,
                totalAmount,
                totalAmountCN: totalAmount / this.rate,
                shippingMethodID: 1
            }
        });

        this.isLoading = false;
    }

    private calculateFeeBuyPro(amount: any) {
        let feeBuyPro = 0;
        if(this.customerInfo.IsSpecialFee > 0) {
            feeBuyPro = Math.round((amount / 100) * this.customerInfo.FeeBuy);
        } else {
            this.feeBuyProRange = this.feeBuyPro.find((fee) => amount >= fee.AmountFrom && amount <= fee.AmountTo);
            const originFeeBuy = Math.round((amount / 100) * this.feeBuyProRange.FeePercent);
            const discountFeeBuy = Math.round((originFeeBuy / 100) * this.customerLevelsDiscount.BuyDiscount);
            feeBuyPro =  Math.round(originFeeBuy - discountFeeBuy);
        }
        
        return feeBuyPro <= this.minFeeBuy ? this.minFeeBuy : feeBuyPro;
    }

    private calculateDeposit(amount: any, feeBuyPro: any) {
        if(this.customerInfo.IsSpecialFee > 0) {
            return Math.floor((amount + feeBuyPro) * this.customerInfo.DepositRate / 100);
        } else {
            return Math.floor((amount + feeBuyPro) * this.customerLevelsDiscount.DepositMin / 100);
        }
    }

    private onCloseModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
    } 
    
    private onOtherModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.$router.push({ name: 'credit' });
        }
    }

    private onAcceptModalWallet(eventData: any) {
        this.isConfirmWallet = !eventData.close || false;
        if (eventData.data === 'OK') {
            this.pushData();
        }
    }

    private async submitData() {
        this.cartStatus = 0;
        if (this.isUseWallet === true) {
            if (this.customerInfo.Wallet < this.totalDeposit.deposit) {
                this.isConfirmWallet = true;
                return;
            }
            this.cartStatus = 2;
        }

        this.pushData();
    }

    private async pushData() {
        this.isLoading = true;
        const dataRequest = this.listCart.map((cart: Cart) => {
            return {
                CartID: cart.id,
                UID: this.userInfo.userId,
                Status: this.cartStatus,
                ShopID: cart.shopId,
                ShopName: cart.shopName,
                Site: cart.site,
                AmountVND: cart.amount,
                AmountCNY: cart.amountCN,
                FeeBuy: this.customerInfo.IsSpecialFee > 0 ? this.customerInfo.FeeBuy : this.feeBuyProRange.FeePercent,
                Deposit: this.cartStatus === 0 ? 0 : cart.deposit,
                FeeBuyAmount: cart.feeBuyPro,
                FeeBuyDiscount: this.customerLevelsDiscount.BuyDiscount,
                FeeWeightDiscount: this.customerLevelsDiscount.WeightDiscount,
                TotalAmountVND: cart.totalAmount,
                ReceivePlaceID: this.customerInfo.ReceivePlaceID,
                Note: cart.note,
                ExchangeRate: this.rate,
                BuyerID: this.customerInfo.BuyerID,
                CustomerServiceID: this.customerInfo.CustomerServiceID,
                ShippingMethodID: cart.shippingMethodID,
                Products: cart.products.map(prod => {
                    return {
                        ProductID: prod.id,
                        title_origin: prod.titleOrigin,
                        image_origin: prod.imageOrigin,
                        link_origin: prod.linkOrigin,
                        data_value: prod.dataValue,
                        item_id: prod.itemId,
                        property: prod.property,
                        quantity: prod.quantity,
                        price_origin: prod.priceOrigin,
                        price_promotion: prod.pricePromotion > 0 ? prod.pricePromotion : prod.priceOrigin,
                        comment: prod.comment
                    }
                }),
            };
        });

        const result = await cartServices.finishCart({ Orders: dataRequest });
        if (result && result.data.status === 200 && result.data.message === 'Success') {
            await this.getCustomersInfo();
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: this.cartStatus === 2 ? 'Đơn hàng tạo thành công!' : 'Đơn hàng tạo thành công, vui lòng đặt cọc để mua hàng',
            });
            (window['getApp'] as any).$emit('SET_SELECTED_CART', null);
            this.$router.push({ name: 'order' });
            this.isLoading = false;
            // this.onComeback();
        } else {
            this.isLoading = false;
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình đặt hàng, vui lòng liên hệ quản trị!',
            });
        }
    }

    private onComeback() {
        this.$router.push({ name: 'cart-index' });
    }
}
